module.exports = __webpack_public_path__ + "img/Jordan.520928be.png";